export default {
	methods: {
		fireLogicOnInit() {
			const hoseOrientation = this.$store.getters['unitConfiguration/data']('hoseOrientation').name;
			this.$store.commit('unitConfiguration/setHoseOrientation', hoseOrientation);
			const instrumentCount = this.$store.getters['unitConfiguration/data']('instrumentCount').name;
			this.$store.commit('unitConfiguration/setInstrumentCount', instrumentCount);
		},
	},
};
